// Import @demvsystems/design styles
import './assets/styles/app.scss';
import '@/assets/Icons/icons';
// import virtual sentry config module from vite plugin
// this imports the dist and release settings used when publishing
import 'virtual:vite-plugin-sentry/sentry-config';

import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { setLocale } from 'yup';

import App from '@/App.vue';
import { setupDevtools } from '@/devtools/devtoolPlugin';
import { initSentry } from '@/features/Sentry/sentry';
import { locales } from '@/features/validation/locales';
import { polyfill } from '@/polyfills';
import router from '@/router';
import { useErrorHandler } from '@/services/errorHandler/useErrorHandler';
import { isDev } from '@/utils/environments/environments';
import { useExitHandler } from '@/utils/useExitHandler/useExitHandler';
import { useLocalStorage } from '@/utils/useLocalStorage/useLocalStorage';

const errorHandler = useErrorHandler();

polyfill();

setLocale(locales);
const app = createApp(App);

initSentry(app, router);

app.use(createPinia()).use(router).mount('#app');

app.config.errorHandler = (err, instance, info) =>
  errorHandler.handle(err, instance, info);

useLocalStorage().checkStorageIsAvailable();

if (isDev()) {
  setupDevtools(app, router);
} else {
  useExitHandler().enable();
}
